import { useContext } from 'react'
import { useTranslation } from 'libs/i18n'
import {
	BuildingStorefrontIcon,
	CubeIcon,
	ShoppingBagIcon,
	WalletIcon
} from '@heroicons/react/24/outline'

import { Summary } from 'shared/components'
import { Currency } from 'shared/components'
import { DashboardContext } from 'store'
import { Currency as CurrencyType } from 'shared/types/general.types'

export const DashboardSummaries = () => {
	const dashboardCtx = useContext(DashboardContext)
	const dashboard = dashboardCtx?.dashboard

	const { t } = useTranslation()

	return (
		<div className="grid gap-4 sm:grid-cols-[repeat(2,1fr)] lg:grid-cols-[repeat(4,1fr)]">
			<Summary
				title={t('Account balance')}
				content={
					<Currency
						price={{
							amount: dashboard?.balance as number,
							currency: dashboard?.currency as CurrencyType
						}}
					/>
				}
				summaryCounter={
					<Currency
						price={{
							amount: dashboard?.profit_last_week as number,
							currency: dashboard?.currency as CurrencyType
						}}
					/>
				}
				summaryText={t('sold last week')}
				icon={<WalletIcon />}
				iconBgColor="bg-success-soft"
				iconColor="text-success"
			/>

			<Summary
				title={t('Products sold')}
				content={dashboard?.products_sold_on_active_bookings}
				summaryCounter={
					dashboard && new Intl.NumberFormat().format(dashboard.products_sold_last_week)
				}
				summaryCounterColor="text-foreground/70"
				summaryText={t('sold last week')}
				icon={<CubeIcon />}
			/>

			<Summary
				title={t('Areas')}
				content={dashboard?.active_booths_count}
				summaryText={t('Active sales area')}
				icon={<BuildingStorefrontIcon />}
				iconBgColor="bg-warning-soft"
				iconColor="text-warning"
			/>

			<Summary
				title={t('Products left')}
				content={dashboard?.products_left_on_active_bookings}
				summaryCounter={
					<Currency
						price={{
							amount: dashboard?.products_total_value.amount as number,
							currency: dashboard?.currency as CurrencyType
						}}
					/>
				}
				summaryText={t('total value')}
				icon={<ShoppingBagIcon />}
				iconBgColor="bg-danger-soft"
				iconColor="text-danger"
			/>
		</div>
	)
}
